<template>
  <v-dialog
    v-model="parentPortalPresentationOtherDialog"
    persistent
    max-width="400"
  >
    <v-card>
      <v-form ref="portalConfigurationFormRef">
        <v-card-title class="primary-background">
          <span>Welcome URL</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="parentPortalPresentationOtherDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row v-if="portalConfigurationModel != null">
              <v-col cols="12">
                <v-text-field
                  v-if="portalConfigurationModel.has_welcome_url != null"
                  label="Welcome URL"
                  v-model="formData.welcome_url"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="parentPortalPresentationOtherDialog = false"
          >
            Fermer
          </v-btn>
          <v-btn color="primary" @click="updatePortal" :loading="loadingSave">
            Enregistrer
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed, ref } from "@vue/composition-api";

export default {
  props: {
    isInherit: Boolean,
    isBuiltIn: Boolean,
    portalOptionsId: Number,
    isGroup: Boolean,
    updatePortalConfiguration: Function,
    id: String,
    portalConfigurationModel: Object,
    group: Object,
    partner: Object,
    portalConfiguration: {
      type: Object,
      required: true,
    },
    portalPresentationOtherDialog: Boolean,
    rules: Object,
    isPortalProfile: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const formData = ref({
      welcome_url: props.portalConfiguration.welcome_url,
    });

    /* Variables */
    const loadingSave = ref(false);

    /* Computed */
    const parentPortalPresentationOtherDialog = computed({
      get: () => props.portalPresentationOtherDialog,
      set: (value) => {
        emit("update:portalPresentationOtherDialog", value);
      },
    });

    /* Méthodes */
    const updatePortal = async function () {
      loadingSave.value = true;
      await props.updatePortalConfiguration(props.id, formData.value);

      loadingSave.value = false;
      parentPortalPresentationOtherDialog.value = false;
    };

    /* Watchers */

    return {
      formData,
      parentPortalPresentationOtherDialog,
      updatePortal,
      loadingSave,
    };
  },
};
</script>
